import { isQueryEnabled } from '@fabric-app/queries/utilities';
import useConfigureRevenueCat from '@/src/modules/pricing/hooks/useConfigureRevenueCat';
import { useIsRevenueCatAvailable } from '@/src/modules/pricing/hooks/useIsRevenueCatAvailable';
import { pricingQueryKeys } from '@/src/modules/pricing/queries/pricingQueryKeys';
import type { CustomerInfo } from '@revenuecat/purchases-capacitor';
import { Purchases } from '@revenuecat/purchases-capacitor';
import type { QueryObserverOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

const useQueryRevenueCatCustomerInfo = (
  queryOptions?: Partial<QueryObserverOptions<CustomerInfo>>,
) => {
  const configureRevenueCat = useConfigureRevenueCat();
  const isRevenueCatAvailable = useIsRevenueCatAvailable();

  return useQuery({
    queryKey: pricingQueryKeys.revenueCatCustomerInfo(),
    queryFn: async () => {
      if (!isRevenueCatAvailable) throw new Error('RevenueCat is not available');

      await configureRevenueCat(); // just in case

      return (await Purchases.getCustomerInfo()).customerInfo;
    },
    ...queryOptions,
    refetchInterval: 1000 * 60, // 1 minute
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: isQueryEnabled([queryOptions?.enabled, isRevenueCatAvailable]),
  });
};

export default useQueryRevenueCatCustomerInfo;
